import { apiFetch } from './client';
import type {
  CustomHtmlData,
  OwnerAnalytics,
  OwnerBusiness,
  OwnerFeedbackItem,
  OwnerLeadItem,
  OwnerMediaItem,
  OwnerProduct,
  Paginated,
  QuotaStatus,
} from '../types';

export const ownerApi = {
  getBusiness: () => apiFetch<OwnerBusiness>('/owner/business'),

  updateBusiness: (data: Partial<OwnerBusiness> & { hours?: OwnerBusiness['hours'] }) =>
    apiFetch<{ id: string; updated: boolean }>('/owner/business', { method: 'PATCH', body: data }),

  getQuota: () => apiFetch<QuotaStatus>('/owner/business/quota'),

  listProducts: () => apiFetch<{ data: OwnerProduct[] }>('/owner/products'),

  bulkCreateProducts: (items: Array<Record<string, unknown>>) =>
    apiFetch<{ created: Array<{ id: string; slug: string }> }>('/owner/products', {
      method: 'POST',
      body: { items },
    }),

  updateProduct: (id: string, data: Record<string, unknown>) =>
    apiFetch<{ id: string; updated: boolean }>(`/owner/products/${id}`, { method: 'PATCH', body: data }),

  deleteProduct: (id: string) => apiFetch<void>(`/owner/products/${id}`, { method: 'DELETE' }),

  listMedia: () => apiFetch<{ data: OwnerMediaItem[] }>('/owner/media'),

  uploadMedia: (file: File, mediaType: string) => {
    const form = new FormData();
    form.append('file', file);
    return apiFetch<{ id: string; url: string }>(`/owner/media?media_type=${mediaType}`, {
      method: 'POST',
      body: form,
      isFormData: true,
    });
  },

  deleteMedia: (id: string) => apiFetch<void>(`/owner/media/${id}`, { method: 'DELETE' }),

  getAnalytics: (days = 30) => apiFetch<OwnerAnalytics>(`/owner/analytics?days=${days}`),

  getFeedback: (page = 1) => apiFetch<Paginated<OwnerFeedbackItem>>(`/owner/feedback?page=${page}`),

  getLeads: (page = 1) => apiFetch<Paginated<OwnerLeadItem>>(`/owner/leads?page=${page}`),

  getCustomHtml: () => apiFetch<CustomHtmlData>('/owner/business/custom-html'),

  updateCustomHtml: (values: Record<string, string>) =>
    apiFetch<{ values: Record<string, string> }>('/owner/business/custom-html', {
      method: 'PATCH',
      body: { values },
    }),
};
